/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExperimentalMutant
 */
export interface ExperimentalMutant {
    /**
     * 
     * @type {number}
     * @memberof ExperimentalMutant
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof ExperimentalMutant
     */
    targetAA: string;
    /**
     * 
     * @type {string}
     * @memberof ExperimentalMutant
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExperimentalMutant
     */
    publications: Array<string>;
}

/**
 * Check if a given object implements the ExperimentalMutant interface.
 */
export function instanceOfExperimentalMutant(value: object): value is ExperimentalMutant {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('targetAA' in value) || value['targetAA'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('publications' in value) || value['publications'] === undefined) return false;
    return true;
}

export function ExperimentalMutantFromJSON(json: any): ExperimentalMutant {
    return ExperimentalMutantFromJSONTyped(json, false);
}

export function ExperimentalMutantFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperimentalMutant {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'targetAA': json['targetAA'],
        'description': json['description'],
        'publications': json['publications'],
    };
}

export function ExperimentalMutantToJSON(json: any): ExperimentalMutant {
    return ExperimentalMutantToJSONTyped(json, false);
}

export function ExperimentalMutantToJSONTyped(value?: ExperimentalMutant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'targetAA': value['targetAA'],
        'description': value['description'],
        'publications': value['publications'],
    };
}

